import React, {FormEvent} from 'react';
import {User, UserRole} from '../../dashboard/types';

interface ProfileTabProps {
  myProfile: User | null;
  authEmail: string;
  authRole: UserRole | '';
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  showCurrentPassword: boolean;
  showNewPassword: boolean;
  showConfirmNewPassword: boolean;
  isUpdatingPassword: boolean;
  setCurrentPassword: (value: string) => void;
  setNewPassword: (value: string) => void;
  setConfirmNewPassword: (value: string) => void;
  toggleShowCurrentPassword: () => void;
  toggleShowNewPassword: () => void;
  toggleShowConfirmNewPassword: () => void;
  onSubmit: (event: FormEvent) => void;
}

export const ProfileTab: React.FC<ProfileTabProps> = (props) => {
  const {
    myProfile,
    authEmail,
    authRole,
    currentPassword,
    newPassword,
    confirmNewPassword,
    showCurrentPassword,
    showNewPassword,
    showConfirmNewPassword,
    isUpdatingPassword,
    setCurrentPassword,
    setNewPassword,
    setConfirmNewPassword,
    toggleShowCurrentPassword,
    toggleShowNewPassword,
    toggleShowConfirmNewPassword,
    onSubmit,
  } = props;

  return (
    <section className='table-card profile-card'>
      <header>
        <h2>My Profile</h2>
      </header>
      <div className='profile-grid'>
        <div className='profile-item'>
          <p className='profile-label'>Name</p>
          <p>{myProfile?.name || 'N/A'}</p>
        </div>
        <div className='profile-item'>
          <p className='profile-label'>Email</p>
          <p>{myProfile?.email || authEmail || 'N/A'}</p>
        </div>
        <div className='profile-item'>
          <p className='profile-label'>Role</p>
          <p>{myProfile?.role || authRole || 'N/A'}</p>
        </div>
        <div className='profile-item'>
          <p className='profile-label'>Status</p>
          <p>{myProfile?.isActive ? 'Active' : 'Inactive'}</p>
        </div>
      </div>
      <form
        className='profile-password-form'
        onSubmit={onSubmit}>
        <h3>Update Password</h3>
        <label htmlFor='current-password'>Current Password</label>
        <div className='profile-password-wrap'>
          <input
            id='current-password'
            type={showCurrentPassword ? 'text' : 'password'}
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            required
          />
          <button
            type='button'
            className='password-toggle-btn'
            onClick={toggleShowCurrentPassword}>
            {showCurrentPassword ? 'Hide' : 'Show'}
          </button>
        </div>
        <label htmlFor='new-password'>New Password</label>
        <div className='profile-password-wrap'>
          <input
            id='new-password'
            type={showNewPassword ? 'text' : 'password'}
            minLength={8}
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            required
          />
          <button
            type='button'
            className='password-toggle-btn'
            onClick={toggleShowNewPassword}>
            {showNewPassword ? 'Hide' : 'Show'}
          </button>
        </div>
        <label htmlFor='confirm-new-password'>Confirm New Password</label>
        <div className='profile-password-wrap'>
          <input
            id='confirm-new-password'
            type={showConfirmNewPassword ? 'text' : 'password'}
            minLength={8}
            value={confirmNewPassword}
            onChange={(event) => setConfirmNewPassword(event.target.value)}
            required
          />
          <button
            type='button'
            className='password-toggle-btn'
            onClick={toggleShowConfirmNewPassword}>
            {showConfirmNewPassword ? 'Hide' : 'Show'}
          </button>
        </div>
        <button className='md:w-6/12 cursor-pointer bg-accentLight text-white px-4 py-2 rounded-full font-semibold hover:bg-accentDark transition-colors duration-300'
          type='submit'
          disabled={isUpdatingPassword}>
          {isUpdatingPassword ? 'Updating...' : 'Update Password'}
        </button>
      </form>
    </section>
  );
};
